module.exports = __webpack_public_path__ + "static/media/ShorelightLogo.5a5b07dc.svg";